import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from 'src/app/providers/environment';
import {
  AgentChatStatus,
  AgentConversation,
  AgentConversationSummary,
  AgentMessageFeedback,
} from 'src/app/types/agent-chat';
import { Response } from 'src/app/types/general';

/** The merchant chat's plain reads (GOO-455); sending a message streams, so it's `AgentChatStreamService`. */
@Injectable({
  providedIn: 'root',
})
export class AgentChatService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  private get url() {
    return this.env.server + '/agent';
  }

  getStatus() {
    return this.http.get<AgentChatStatus>(this.url + '/status');
  }

  /** Newest first, without the messages. */
  getConversations(params: { skip: number; limit: number }) {
    return this.http.get<Response<AgentConversationSummary>>(this.url + '/conversations', { params: { ...params } });
  }

  /** Opening a conversation marks the team's replies in it as read. */
  getConversation(id: string) {
    return this.http.get<AgentConversation>(this.url + '/conversations/' + id);
  }

  /** Rates one of the agent's replies; rating it again replaces the earlier rating. */
  setFeedback(conversationId: string, messageId: string, feedback: AgentMessageFeedback) {
    return this.http.put<AgentConversation>(
      `${this.url}/conversations/${conversationId}/messages/${messageId}/feedback`,
      feedback,
    );
  }
}
